import React, { useEffect, useState } from 'react';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
import { LabelMedium, ParagraphMedium } from 'baseui/typography';
import { MEDIA_MESSAGES } from '../../image/labelling/components/video/constants/error-messages';
import { BUFFER_TIME_FOR_SIGNED_URL_REFRESH } from '../constant/constant';
type PropsT = {
  timeRemaining?: number;
  onTimerEnd?: () => void;
};
const MILLISECONDS_IN_SECOND = 1000;
const subHeadingStyle = (theme: Theme) => ({
  marginTop: theme.sizing.scale100,
  marginBottom: 0
} as const);
export const RefreshSignedUrlInfo = ({
  timeRemaining,
  onTimerEnd
}: PropsT) => {
  const [css, theme] = useStyletron();
  const defaultTimeRemaining = timeRemaining && timeRemaining > 0 ? timeRemaining : BUFFER_TIME_FOR_SIGNED_URL_REFRESH;
  const [timeRemainingBeforeRefresh, setTimeRemainingBeforeRefresh] = useState(defaultTimeRemaining);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemainingBeforeRefresh((currentTimeRemaining: number) => {
        if (currentTimeRemaining <= MILLISECONDS_IN_SECOND) {
          onTimerEnd?.();
          clearInterval(timer);
          return 0;
        }
        return currentTimeRemaining - MILLISECONDS_IN_SECOND;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [onTimerEnd]);
  return <div>
      <LabelMedium color={theme.colors.contentInversePrimary}>
        {MEDIA_MESSAGES.REFRESH_AFTER_TIMEOUT_MESSAGE_HEADING(timeRemainingBeforeRefresh / 1000)}
      </LabelMedium>
      <ParagraphMedium color={theme.colors.contentInversePrimary} className={css(subHeadingStyle(theme))}>
        {MEDIA_MESSAGES.REFRESH_AFTER_TIMEOUT_MESSAGE_SUB_HEADING}
      </ParagraphMedium>
    </div>;
};